export default "/kiban/_next/static/images/japan-1219c132ec1be3a7491c8540f826c325.png";